import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'
import { setHeader } from '../actions'
import OrganizationList from '../components/OrganizationList'
import OrganizationEdit from '../components/OrganizationEdit'
import Teams from '../components/Teams'

class Organization extends Component {
  componentWillMount() {
    this.initializeHeader()
  }
  componentDidUpdate() {
    this.initializeHeader()
  }
  initializeHeader() {
    const { setHeader, url } = this.props
    const header = (url === "/organization")? {
      title: "組織構成",
      left: null,
      right: {
        text: 'edit',
        url: "/organization/edit",
        admin: true
      }
    } : {
      title: "組織編集",
      left: {
        text: 'back',
        url: "/organization"
      },
      right: null
    }
    setHeader(header)
  }
  render() {
    const { users, url, organizationImage } = this.props
    return (
      users?
        <div className="organization content">
          { (url === "/organization" && organizationImage )? <img src={organizationImage} alt="organizationImage" /> : null }
          <Switch>
            <Route exact path='/organization' render={() => <Teams component={OrganizationList} />} />
            <Route path='/organization/edit' render={() => <Teams component={OrganizationEdit} />} />
          </Switch>
        </div>
      :
        <div>Loading...</div>
    )
  }
}

export default connect(
  state => ({ 
    users: state.users,
    organizationImage: state.organization.image
  }),
  { setHeader }
)(Organization)


// WEBPACK FOOTER //
// ./src/containers/Organization.js